const DETAIL_PLANNING_RESEAU_LC = {
  title: 'Planning réseau LC',
  racine: 'Accueil',
  actions: {
    filtre: 'Filtre',
  },
  tab: {
    libelle: 'Libellé',
    ville: 'Ville',
    societe: 'Société',
  },
  filtreContent: {
    titre: 'Filtre',
    appliquerFiltre: 'Les filtres seront appliqués à la liste',
    reseauConfrere: 'Inclure réseaux confrères',
    codeReseau: 'Code réseau',
    villes: 'Villes réseau',
    libelle: 'Libellé',
    formats: 'Format',
    appliquer: 'Appliquer',
    societe: 'Société',
    reinitialiser: 'Réinitialiser',
  },
};

export default DETAIL_PLANNING_RESEAU_LC;
